import React from 'react'

import { Div } from '@driftt/tide-core'

import Title from '../Title'

import './style.css'

export interface IChartHeaderProps {
  cumulative?: boolean
  title?: string
  tooltip?: string
  tooltipFlow?: string
  inlineCountChart?: (() => React.ReactNode) | false
  subtitle?: string | React.ReactNode

  renderPrimaryContent?: (() => React.ReactNode) | false
  renderAdditionalContent?: (() => React.ReactNode) | false
  renderBottomContent?: (() => React.ReactNode) | false
}

const renderSubtitle = (
  subtitle: string | React.ReactNode,
  cumulative?: boolean
) => {
  if (typeof subtitle === 'string') {
    let result = ''
    if (cumulative) {
      result += 'Cumulative | '
    }
    result += subtitle
    if (subtitle.includes('This')) {
      result += ' so far'
    }
    return result
  }

  return subtitle
}

const ChartHeader = ({
  cumulative,
  title,
  tooltip,
  tooltipFlow,
  subtitle,
  inlineCountChart,
  renderPrimaryContent,
  renderAdditionalContent,
  renderBottomContent,
}: IChartHeaderProps) => (
  <Div className="chart-header">
    <Div className="chart-header-content">
      {(title || subtitle || renderPrimaryContent) && (
        <Div className="chart-header-primary-content">
          {title && (
            <Div className="chart-header-title">
              <Title
                title={title}
                tooltip={tooltip}
                tooltipFlow={tooltipFlow}
              />
            </Div>
          )}
          {subtitle && (
            <Div className="chart-header-subtitle">
              {renderSubtitle(subtitle, cumulative)}
            </Div>
          )}
          {inlineCountChart && inlineCountChart()}
          {renderPrimaryContent && (
            <Div className="chart-header-custom-primary-content-custom">
              {renderPrimaryContent()}
            </Div>
          )}
        </Div>
      )}
      {renderAdditionalContent && (
        <Div className="chart-header-additional-content">
          {renderAdditionalContent()}
        </Div>
      )}
    </Div>
    {renderBottomContent && (
      <Div className="chart-header-bottom-content">{renderBottomContent()}</Div>
    )}
  </Div>
)

export default ChartHeader
